import api from './api';

export const orderService = {
  // Get seller orders
  getSellerOrders: async (params = {}) => {
    const response = await api.get('/api/orders/seller/orders/', { params });
    return response.data;
  },

  // Update order status
  updateOrderStatus: async (orderId, statusData) => {
    const response = await api.patch(`/api/orders/seller/orders/${orderId}/update-status/`, statusData);
    return response.data;
  },

  // Get order tracking
  getOrderTracking: async (orderId) => {
    const response = await api.get(`/api/orders/orders/${orderId}/track/`);
    return response.data;
  },

  // Create shipment for order
  createShipment: async (orderId, shipmentData = {}) => {
    const response = await api.post('/api/shipping/shipments/create/', {
      order_id: orderId,
      ...shipmentData
    });
    return response.data;
  },

  // Generate invoice
  generateInvoice: async (orderId) => {
    const response = await api.post(`/api/orders/seller/orders/${orderId}/generate-invoice/`);
    return response.data;
  },

  // Get invoice view/download URL
  getInvoiceUrl: (orderId, download = false) => {
    const baseUrl = process.env.REACT_APP_API_URL || 'https://api.whatnew.live';
    return `${baseUrl}/api/orders/orders/${orderId}/invoice/${download ? '?download=true' : ''}`;
  }
};




